import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MondayProvider } from './context/MondayContext';
import { UserAccessProvider } from './hooks/useCurrentUserAccess';
import { SubscriptionProvider } from './context/SubscriptionContext';
import AccessGate from './components/shared/AccessGate';
import SubscriptionGate from './components/shared/SubscriptionGate';
import BoardView from './views/BoardView';
import ItemView from './views/ItemView';
import DashboardWidget from './views/DashboardWidget';
import WorkspaceView from './views/WorkspaceView';

const App: React.FC = () => {
  return (
    <MondayProvider>
      <UserAccessProvider>
        <AccessGate>
          <SubscriptionProvider>
            <SubscriptionGate>
              <Routes>
                <Route path="/board-view" element={<BoardView />} />
                <Route path="/item-view" element={<ItemView />} />
                <Route path="/dashboard-widget" element={<DashboardWidget />} />
                {/* Workspace view with nested routes for sub-sections */}
                <Route path="/workspace/*" element={<WorkspaceView />} />
                {/* Default redirect - monday.com will load the appropriate path */}
                <Route path="*" element={<Navigate to="/board-view" replace />} />
              </Routes>
            </SubscriptionGate>
          </SubscriptionProvider>
        </AccessGate>
      </UserAccessProvider>
    </MondayProvider>
  );
};

export default App;
